import { createApiCall } from 'lib/base';

// "id" maps to the ICB code string (e.g. "8355") in the URL param
const makeDeleteCall = (key: string, path: string) =>
  createApiCall<{ id: string }>(key, ({ id }) => ({
    endpoint: `api/admin/${path}/${id}`,
    method: 'DELETE',
  }));

export const deleteIndustry = makeDeleteCall(
  'DELETE_ICB_INDUSTRY',
  'stock-icb/industries'
);
export const deleteSuperSector = makeDeleteCall(
  'DELETE_ICB_SUPERSECTOR',
  'stock-icb/supersectors'
);
export const deleteSector = makeDeleteCall(
  'DELETE_ICB_SECTOR',
  'stock-icb/sectors'
);
export const deleteSubSector = makeDeleteCall(
  'DELETE_ICB_SUBSECTOR',
  'stock-icb/subsectors'
);
